import { render, staticRenderFns } from "./BlockCase.vue?vue&type=template&id=9e5d2cc6"
import script from "./BlockCase.vue?vue&type=script&lang=js"
export * from "./BlockCase.vue?vue&type=script&lang=js"
import style0 from "./BlockCase.vue?vue&type=style&index=0&id=9e5d2cc6&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports